import React, { useState, useEffect, useCallback } from "react";
import Button from "@mui/material/Button";

/**
 * TelegramHomeShortcutButton
 * 可复用按钮组件，封装了 Telegram WebApp “添加到主屏幕”逻辑
 *
 * Props:
 * - label?: string           按钮文字，默认 "添加到桌面"
 * - loadingLabel?: string    加载状态文字，默认 "加载中..."
 * - buttonProps?: object     可传入 MUI Button 的其它 props
 */
const TelegramHomeShortcutButton = ({
  label = "快捷添加",
  loadingLabel = "加载中...",
  buttonProps = {},
}) => {
  const [homeStatus, setHomeStatus] = useState("unknown"); // added | missed | unsupported | unknown | pending
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const webApp = window.Telegram?.WebApp;

    if (!webApp || !webApp.checkHomeScreenStatus) {
      setHomeStatus("unsupported");
      return;
    }

    try {
      setHomeStatus("pending"); // 可选，显示加载中
      const status = webApp.checkHomeScreenStatus(); // 同步调用
      setHomeStatus(status || "unsupported"); // 避免返回 undefined
    } catch (err) {
      console.error("检查主屏幕状态失败:", err);
      setHomeStatus("unsupported");
    }
  }, []);

  const handleAddToHome = useCallback(() => {
    const webApp = window.Telegram?.WebApp;

    if (!webApp || !webApp.addToHomeScreen) {
      
      return;
    }

    setLoading(true);
    try {
      webApp.addToHomeScreen();
      setHomeStatus("added"); // 假设成功后状态会自动更新
    } catch (err) {
      console.error("添加到桌面失败:", err);
      alert("添加失败，请稍后重试");
    } finally {
      setLoading(false);
    }
  }, []);

  // 如果已添加、不支持、状态未知或 undefined，就隐藏按钮
  if (!homeStatus || homeStatus === "added" || homeStatus === "unsupported" || homeStatus === "unknown") {
    return null;
  }

  return (
    <Button
      variant="contained"
      size="small"
      disabled={loading || homeStatus === "pending"}
      sx={{
        bgcolor: "rgba(255,255,255,0.9)",
        color: "#000",
        fontWeight: 600,
        borderRadius: "999px",
        px: 2,
        textTransform: "none",
        "&:hover": { bgcolor: "#fff" },
        minWidth: 100,
        ...buttonProps.sx,
      }}
      onClick={handleAddToHome}
      {...buttonProps}
    >
      {loading || homeStatus === "pending" ? loadingLabel : label}
    </Button>
  );
};

export default TelegramHomeShortcutButton;
